import React, { useLayoutEffect } from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOHeadProps {
  title: string;
  description?: string;
  canonicalPath?: string;
}

const BASE_URL = 'https://top-bhs.de';

const SEOHead: React.FC<SEOHeadProps> = ({ title, description, canonicalPath }) => {
  const canonical = canonicalPath ? `${BASE_URL}${canonicalPath}` : undefined;

  // Set document.title directly so react-snap captures it synchronously
  useLayoutEffect(() => {
    document.title = title;
    if (description) {
      const meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute('content', description);
    }
  }, [title, description]);

  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {canonical && <link rel="canonical" href={canonical} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:title" content={title} />
      {canonical && <meta property="og:url" content={canonical} />}
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
    </Helmet>
  );
};

export default SEOHead;
